/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// Public API for Zone
export {NgZone, NoopNgZone as ÉµNoopNgZone} from './zone/ng_zone';
